import React, { useState } from "react";
import "../styles/Reviews.css";
import Reveal from "./Reveal";

export default function Reviews({ animated = false }) {
  const [reviews] = useState([
    {
      name: "Rahul",
      text: "The AWS training at Confideo was exactly what I needed. Every module had hands-on labs, and the real-world projects helped me understand VPC, IAM, and deployment pipelines in practice. Within two months I was confident enough to apply for cloud roles.",
      size: "long",
    },
    {
      name: "Priya",
      text: "Helped me crack cloud interviews easily.",
      size: "short",
    },
    {
      name: "Kiran",
      text: "Very structured and easy to understand.",
      size: "short",
    },
    {
      name: "Ananya",
      text: "Coming from a non-IT background, I was nervous about cloud computing. The step-by-step approach and patient instructors made everything click. I now work on Azure deployments at my company thanks to the skills I gained here.",
      size: "long",
    },
    {
      name: "Vikram",
      text: "Great Multi-Cloud program!",
      size: "short",
    },
    {
      name: "Sneha",
      text: "Mock interviews and resume reviews were super helpful. Landed my first DevOps role two weeks after finishing.",
      size: "medium",
    },
    {
      name: "Arjun",
      text: "Best hands-on training I've done.",
      size: "short",
    },
    {
      name: "Meera",
      text: "I tried YouTube tutorials before but kept getting stuck. Here the live doubt sessions and project walkthroughs made Kubernetes and Terraform actually make sense. Worth every rupee for working professionals.",
      size: "long",
    },
  ]);

  const header = (
    <div className="testimonials-header">
      <h2>Student voices that show the journey.</h2>
      <p className="section-subtitle testimonials-subtitle">
        Real stories from learners who joined confideo cloud & code, built confidence, and moved closer to their goals.
      </p>
    </div>
  );

  const stats = (
    <div className="testimonial-stats">
      <div>
        <strong>1,200+</strong>
        <span>Learners guided</span>
      </div>
      <div>
        <strong>95%</strong>
        <span>Session completion</span>
      </div>
      <div>
        <strong>1:1</strong>
        <span>Career support</span>
      </div>
    </div>
  );

  const marquee = (
    <div className="reviews-marquee">
      <div className="reviews-track">
        {[...reviews, ...reviews].map((r, index) => (
          <div
            className={`review review-${r.size} ${index % 2 === 0 ? "review-featured" : "review-alt"}`}
            key={index}
          >
            <p>"{r.text}"</p>
            <div className="review-footer">
              <span className="review-avatar">{r.name.charAt(0).toUpperCase()}</span>
              <span className="review-name">{r.name}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  if (!animated) {
    return (
      <section id="reviews" className="section testimonials-section">
        {header}
        {stats}
        {marquee}
      </section>
    );
  }

  return (
    <section id="reviews" className="section testimonials-section">
      <Reveal variant="up">{header}</Reveal>
      <Reveal variant="up" delay={1}>{stats}</Reveal>
      <Reveal variant="fade" delay={2}>{marquee}</Reveal>
    </section>
  );
}
